import axiosInstance from '../../../config/axiosInstance';
const AgreementService = {
    async GetAllAgreement(redirectCallback, ClientCompanyID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Agreement/GetAllAgreement?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AllNewAgreement(redirectCallback, ClientCompanyID,Start, PageSize, searchQuery, sortColumn, sortDirection,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Agreement/AllNewAgreement?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAgreementCount(redirectCallback, ClientCompanyID,searchQuery,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Agreement/GetAgreementCount?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&searchQuery=${searchQuery}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAgreementByID(redirectCallback, ID) {
        try {
            const response = await axiosInstance.get(`/Agreement/GetContractByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetContractExpirey(redirectCallback, ContractID) {
        try {
            const response = await axiosInstance.get(`/Agreement/GetContractExpirey?ContractID=${ContractID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAgreementDescriptionByID(redirectCallback, ID) {
        try {
            const response = await axiosInstance.get(`/Agreement/GetContractDescriptionByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async DeleteAgreement(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Agreement/DeleteAgreement?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async AgreementAutoRef(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Agreement/AgreementAutoRef?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async RenewAgreement(ID, redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Agreement/RenewAgreement?ID=${ID}`);
            debugger;
            return response.data.message;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async LockContract(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Agreement/LockContract?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockContract(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Agreement/UnLockContract?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
};

export default AgreementService;